const config = require("../appConf");

const MessagesClient = {
  buildHeaders(token) {
    return {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    };
  },

  debug() {
    return process && process.env === "development";
  },

  async fetchWithTimeout(url, options) {
    const { timeout = 2000, ...fetchOptions } = options;

    const controller = new AbortController();
    const { signal } = controller;

    setTimeout(() => controller.abort(), timeout);

    const fetchData = fetch(url, { ...fetchOptions, signal });

    return fetchData;
  },

  /**
   * Generic method to retrieve the full messages list
   *
   * @param token : authentication token
   */
  async _getMessages(token) {
    const url = `${config.url}/message?limit=1000&status=SENT`;
    try {
      const response = await (await this.fetchWithTimeout(url, { headers: this.buildHeaders(token) })).json();
      return response;
    } catch (e) {
      return [];
    }
  },

  /**
   * Generic method to retrieve the READ messages list
   *
   * @param {*} token : authentication token
   * @param {*} limit : max number of messages to get
   * @param {*} page : page number
   */
  async _getReadMessages(token, limit = 100, page = 1) {
    const url = `${config.url}/message?limit=${limit}&status=READ&page=${page}`;
    try {
      const response = await (await this.fetchWithTimeout(url, { headers: this.buildHeaders(token) })).json();
      return response;
    } catch (e) {
      return [];
    }
  },

  /**
   * Mark a single message as READ
   *
   * @param {*} token : authentication token
   * @param {*} messageId : id of the message object to mark as READ
   */
  async _readObject(token, messageId) {
    const url = `${config.url}/message/${messageId}/read`;
    const response = await (
      await fetch(url, { headers: this.buildHeaders(token), method: "PATCH", body: JSON.stringify({}) })
    ).json();
    if (this.debug()) console.log("#### READ MESSAGE", response);
    if (this.debug()) console.log("#### READ MESSAGE - STRING", JSON.stringify(response));
    return response;
  },

  /**
   * Get the list of messages in the root folder
   *
   * @param {*} token : authentication token
   */
  async getAll(token) {
    const all = await this._getMessages(token);
    if (this.debug()) console.log("#### LOADED MESSAGES", all);
    if (this.debug()) console.log("#### LOADED MESSAGES - STRING", JSON.stringify(all));
    return all;
  },

  /**
   * Get the list of READ messages
   *
   * @param {*} token : authentication token
   * @param {*} limit : max number of messages to get
   * @param {*} page : page number
   */
  async getAllRead(token, limit, page) {
    const all = await this._getReadMessages(token, limit, page);
    if (this.debug()) console.log("#### LOADED MESSAGES", all);
    if (this.debug()) console.log("#### LOADED MESSAGES - STRING", JSON.stringify(all));
    return all;
  },

  /**
   * Mark a message as READ
   *
   * @param {*} token : authentication token
   * @param {*} messageId : message object id
   */
  async markAsRead(token, messageId) {
    if (!messageId && this.debug()) console.log("#### Message ID not set!");
    const read = await this._readObject(token, messageId);
    if (!read) return {};
    return read;
  },
};

module.exports = MessagesClient;
